// Shared Trash route; kept under /app/assets/folders (not the legacy
// zaps/folders path) so it stays on FoldersLayout.
export const TRASH_HREF = "/app/assets/folders/trash";
